import * as yup from 'yup';

export const hexColorRegex = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;

export const validations = yup.object().shape({
  primaryColor: yup
    .string()
    .matches(hexColorRegex, 'Informe uma cor hexadecimal válida (ex: #022A5C)'),
  secondaryColor: yup
    .string()
    .matches(hexColorRegex, 'Informe uma cor hexadecimal válida (ex: #FFFFFF)'),
  darkModeEnabled: yup
    .bool()
});